module.exports = {"name":"","icons":[{"src":"/favicons/android-chrome-192x192.png","sizes":"192x192","type":"image/png"},{"src":"/favicons/android-chrome-512x512.png","sizes":"512x512","type":"image/png"}],"theme_color":"#ffffff","display":"standalone"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/manifest.json
// module id = 39
// module chunks = 0